import { orderBy } from 'lodash'

export const getResidentsList = (state) => state.data.residents
export const getHomeDocumentsList = (state) => state.data['home-documents']
export const getUsersList = (state) => state.data.carers
export const getLogsList = (state) => state.data.logs
export const getHandoversList = (state) => state.data.handovers
export const getCurrentHandover = (state) => state.handovers.current
export const getLogCategories = (state) => state.data['log-categories']
export const getLogCategoryItems = (state) => state.data['log-category-items']
export const getZonesList = (state) => state.data.zones
export const getCarePlanList = (state) => state.data['care-plans']
export const getFormsList = (state) => state.data.forms
export const getRiskAssessmentList = (state) => state.data['risk-assessments']
export const getInitialAssessmentsList = (state) =>
  state.data['initial-assessments']
export const getRecurringTodos = (state) => state.todos.recurring
export const getDailyTodos = (state) => state.todos.today
export const getAllFormData = (state) => state.forms
export const getUserHome = (state) => state.global.home
export const usePropsFormFields = (_state, props) => props.fields

export const getEMARRounds = (state) => state.data['emar-rounds']
export const getEMARRoundTimings = (state) =>
  orderBy(state.data['emar-round-timings'], 'time')
export const getEMARResidentMeds = (state) =>
  state.data['emar-resident-medications']
export const selectFirstItem = (state, { listId }) =>
  state.data[listId] && state.data[listId][0] && state.data[listId][0].id

// Care plans
export const getAdls = (state) => state.carePlans.adls
export const getCarePlanHistory = (state) => state.carePlans.history

// Consent
export const getConsentForms = (state) => state.data['consent-forms']
export const getConsentFormTemplates = (state) =>
  state.data['consent-templates']

// Needs and Skills
export const getSkills = (state) => state.data?.skills
export const getNeeds = (state) => state.data?.needs
export const getTemplateCategories = (state) =>
  state.data['skill-need-templates/categories']
export const getSkillNeedTemplates = (state) =>
  state.data?.['skill-need-templates']
